import React, { useEffect, useState, memo } from 'react';
import styled from 'styled-components/native';

const TimerBar = memo(({ callbackFunction, timerLength }) => {
  const [width, setWidth] = useState(0);
  const [currentTime, setCurrentTime] = useState('0:00');

  useEffect(() => {
    let isMounted = true;
    let secondsElapsed = 0;

    const interval = setInterval(() => {
      setWidth(prevWidth => {
        if (prevWidth < 100) {
          secondsElapsed++;
          setCurrentTime(secondsToMS(secondsElapsed));
          return prevWidth + 100/timerLength;
        } else {
          clearInterval(interval);
          if (isMounted) {
            callbackFunction();
          }
          return prevWidth;
        }
      });
    }, 1000);

    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [timerLength, callbackFunction]);

  function secondsToMS(seconds){
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  }


  return (
      <TimerBarParent>

        <TimerTextCont>
          <CurrentTimeText>{currentTime}</CurrentTimeText>
          <TotalTimeText>{secondsToMS(timerLength)}</TotalTimeText>
        </TimerTextCont>

        <TimerBarCont>
          <Bar style={{width: `${width}%`}}/>
        </TimerBarCont>
      </TimerBarParent>

  );
});



export const TimerBarParent = styled.View`
  position:absolute;
  top:50px;
  left:0; 
  right:0;
  width:100%;
  height:auto;
  display:flex;
  justify-content:center;
  align-items:center;
`

export const TimerTextCont = styled.View`
  width:80%;
  height:auto;
  display:flex;
  justify-content:space-between;
  align-items:flex-start;
  flex-direction:row;
  margin-bottom:5px;
`

export const CurrentTimeText = styled.Text`
  font-size:16px;
  font-family:Montserrat-RG;
  color:#3366cc;
`

export const TotalTimeText = styled.Text`
  font-size:16px;
  font-family:Montserrat-RG;
  color:#3366cc;
`

export const TimerBarCont = styled.View`
    width:80%;
    height:14.5px;
    display:flex;
    justify-content:flex-start;
    align-items:flex-start;
    overflow:hidden;
    border:1px solid #b8daff;
    border-radius:50px;
`

export const Bar = styled.View`
    height:14.5px;
    width:25px;
    background:#b8daff;
`



export default TimerBar;
